// Copyright (c) Ping. All rights reserved.
//
// `outlineStyle: 'none'` strips the focus ring on react-native-web's
// `<TextInput>` (a DOM <input>), but it is NOT a valid RN style key —
// react-native-macos logs "Invalid props.style key `outlineStyle`" and
// rejects it. Gate it to web so the same shared component is clean on
// both platforms.

import { Platform } from 'react-native';

/** `{ outlineStyle: 'none' }` on web, `undefined` elsewhere. Spread/assign
 *  into a `<TextInput>` `style` (RN tolerates `undefined`/falsy entries). */
export const WEB_INPUT_OUTLINE_RESET: object | undefined =
  Platform.OS === 'web' ? ({ outlineStyle: 'none' } as object) : undefined;
